import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { AutoRedeemDialogComponent } from '../auto-redeem-dialog/auto-redeem-dialog.component';
import { ModalDefaultPaymentComponent } from 'src/app/shared/components/modal-default-payment/modal-default-payment.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { UserService } from 'src/app/shared/services/user.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { GetPayinTokensService } from 'src/app/shared/services/api/get-payin-tokens.service';
import { GetAutoPaySequenceService } from 'src/app/shared/services/api/get-auto-pay-sequence.service';
import { filter, findIndex } from 'rxjs';

@Component({
  selector: 'app-auto-redeem',
  templateUrl: './auto-redeem.component.html',
  styleUrls: ['./auto-redeem.component.scss']
})


export class AutoRedeemComponent implements OnInit {
  private modalOpened: boolean = false; // Add this flag
  isOn = false;
  walletRole:string='';
@Output() toggleChange = new EventEmitter<boolean>();

toggle() {
  this.isOn = !this.isOn;
  this.toggleChange.emit(this.isOn);
}

  cardType: any;
  lastFourDigits: any;
  ccExpiration: any;
  isExpired: boolean = false;
  isWarning: boolean = false;

  ONLSessionDetails: any;
  walletDetails: any;

  //autopayOptions: any;
  autopayOptions: any[] = [];

  currentSelection: any;
  autopayToggle: boolean = false;
  toggleText: string = 'Off';  // Default toggle text
  isPPI: boolean = false;  

   ppiOptions = {
    rewards: false,
    cash: false
  };

  loading: boolean = false;
  systemError: boolean = false;
  defaultError: boolean = false;
  is4uError: boolean = false;
  successMessage: boolean = false;
  disableButton: boolean = false;
  buttonLoading: boolean = false;
  initialState: any;
  isAutoTransferOn:boolean=false;

  initialAutoRedeemStatus: boolean = false;
  isBilliant: boolean = false;

  @Output() autopayResult = new EventEmitter<any>();

  constructor(
    private router: Router,
    private dialog: MatDialog,
    public route: ActivatedRoute,
    private userService: UserService,
    private sessionService: SessionService,
    public getpayintoken: GetPayinTokensService,
    private getAutoPaySequence: GetAutoPaySequenceService
  ) {
    this.ONLSessionDetails = this.userService.getONLSessionDetails();
    this.walletRole = JSON.parse(sessionStorage.getItem("WalletRole"));
    const walletDetails = this.userService.getWalletDetails();
    this.isPPI = this.sessionService.isPPI(); ; 
    this.isBilliant=sessionStorage.getItem("isBilliant")!=null?sessionStorage.getItem("isBilliant").toLocaleLowerCase()=="true"?true:false:false;
    // I would want to pull this item directly from sessionStorage, however in fear of potential sync issues I am going to make another call for now in ngOninit
    // this.walletDetails = this.userService.getWalletDetails();
  }

  // Function to handle drag and drop/rearranging of items in the array
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex == 0 && event.currentIndex == 2) {
      // The item in index 2 (default payment method) cannot be moved out of index 2, so do not swap 0 and 2 here
      // However, still swap 0 and 1 in case the user was intending to swap the first two items, but accidentally dragged a bit too low
      moveItemInArray(this.autopayOptions, 0, 1);
    } else if (event.previousIndex == 1 && event.currentIndex == 2) {
      // Do nothing (cannot move the item in index 1 into index 2. The index 2 item is immoveable and must remain there at all times)
    } else {
      moveItemInArray(this.autopayOptions, event.previousIndex, event.currentIndex);
    }
  }

ngOnInit() {
  this.ONLSessionDetails = this.userService.getONLSessionDetails();
  this.walletDetails = JSON.parse(sessionStorage.getItem('walletDetails')!);

  this.walletRole = JSON.parse(sessionStorage.getItem("WalletRole"));
  this.isPPI = this.sessionService.isPPI();

  // Always fetch fresh wallet summary (works for ONL + PPI)
  const wd = this.walletDetails || {};
    if (wd?.isDWAutoAutoRedeem !== undefined) {
        const isSavedTrue = wd.isDWAutoAutoRedeem?.toLowerCase() === 'true';
        this.autopayToggle = isSavedTrue;
        this.toggleText = isSavedTrue ? 'On' : 'Off';
        
        // CRITICAL: Store the initial status immediately
        this.initialAutoRedeemStatus = isSavedTrue; 
    }
  this.getWalletSummaryAndLoadPage();

  // Auto-transfer handling (ONL only, safe fallback for PPI too)
  let autotransfer = JSON.parse(sessionStorage.getItem('AutoTransfer')!);
  this.isAutoTransferOn = autotransfer?.isAutoTransfer;

  // Handle default payment modal redirect
  this.route.queryParams.subscribe(params => {
    if (params['from'] === 'auto-redeem' && this.walletDetails?.defaultPaymentMethod?.toLowerCase() !== 'true') {
     if (!this.isPPI) {
            this.openSetDefaultPaymentModal('auto-redeem');
        }
      // this.openSetDefaultPaymentModal('auto-redeem');
      console.log("default payment method is FALSE from auto-redeem page");
    }
  });
}



  checkDefaultPaymentMethod(): void {
    // Assuming you have a method to check if the default payment method is set
    const isDefaultPaymentMethodSet = this.findDefaultPaymentMethod();

    if (!this.findDefaultPaymentMethod) {
      // Redirect to home page with a query parameter to show the modal
      this.router.navigate(['/home'], { queryParams: { showDefaultPaymentModal: true } });
    }
  }

  // Function to get wallet summary from either the API or sessionStorage. Afterwards, load the page
getWalletSummaryAndLoadPage() {
  this.loading = true;
  this.systemError = false;
  this.defaultError = false;
  this.successMessage = false;
  this.disableButton = false;

  let request = {
    sessionID: sessionStorage.getItem("SessionID"),
    walletID: JSON.parse(sessionStorage.getItem("WalletID")!),
    walletRole: JSON.parse(sessionStorage.getItem("WalletRole")!)
  };

  this.userService.getWalletSummary(request).subscribe(
    data => {
      let activeWallet = null;

  if (this.isPPI) {
                // If in a PPI session, prioritize the PPI data
                if (data?.ppi?.wallet) {
                    activeWallet = data.ppi.wallet;
                    console.log("Data for PPI Wallet: ", activeWallet);
                    
                    // Always ensure payment data is linked if it exists separately
                    if (data?.ppi?.wallet?.payment) {
                        activeWallet.payment = data.ppi.wallet.payment;
                    }
                }
            } else {
                // If NOT in a PPI session (i.e., ONL session), prioritize the ONL data
                if (data?.onl?.wallet) {
                    activeWallet = data.onl.wallet;
                    console.log("Data for ONL Wallet: ", activeWallet);
                }
            }

      // ✅ Legacy fallback
        if (!activeWallet && data?.wallet) {
                activeWallet = data.wallet;
                console.log("Data for Legacy Wallet: ", activeWallet);
            }

      if (activeWallet) {
        sessionStorage.setItem("walletDetails", JSON.stringify(activeWallet));
        this.walletDetails = activeWallet;
        console.log("DEBUG walletDetails loaded:", this.walletDetails);

        // Decide which load method to run
        if (this.isPPI) {
          this.loadAutoPayOptionsPPI();
        } else {
          this.loadAutoPayOptions();
        }
      } else {
        this.loading = false;
        this.disableButton = true;
        this.systemError = true;
        console.error("Wallet data not found in API response.");
      }
    },
    error => {
      console.error("Error fetching wallet summary:", error);
      this.loading = false;
      this.disableButton = true;
      this.systemError = true;
    }
  );
}


  // Function to determine if the user should be allowed to view the autopay screen or not.
  // If so, display the 3 autopay options in the correct order. If not, navigate them away from the page or display an error message.
  loadAutoPayOptions() {
    this.loading = false;
    if (!(this.ONLSessionDetails?.productSystemIdentifier1 && (this.ONLSessionDetails?.productSystemIdentifier2 || this.isBilliant) && this.ONLSessionDetails?.productSystem)) {
      // If any of these three fields are missing, we probably should log the user out. For now, just display the error message.
    //  this.loading = false;
      this.disableButton = true;
      this.systemError = true;
      return;
    } else if (this.walletDetails?.defaultPaymentMethod?.toLocaleLowerCase() != 'true') {
      // If user does not have a default payment method set, prompt them with a pop-up that they need to set a default payment method.
      //this.loading = false;
      this.disableButton = true;
      this.defaultError = true;
      setTimeout(() => {
        this.openSetDefaultPaymentModal('auto-redeem'); 
      }, 500); // Delay ensures page is fully loaded before showing modal
      return;
    //  this.openSetDefaultPaymentModal();
     // this.router.navigate(['/home'], { queryParams: { showDefaultPaymentModal: true } });
    } else if (this.walletDetails?.rewardEligible?.toLocaleLowerCase() != 'true' && !this.isBilliant) {
      // If user is IS4U user (aka rewardEligible is not true), they are not allowed to see the page.
   //   this.loading = false;
      this.disableButton = true;
      this.is4uError = true;
    } else if (this.walletDetails?.payment?.cardType && this.walletDetails?.payment?.last4Digits && this.walletDetails?.token) {
      // User is allowed to view the autopay page, and has their default payment method info in walletDetails
      this.setDefaultPaymentInfo();
      this.setOrderForAutopayOptions();
    } else {
      // User has defaultPaymentMethod = 'true', but for some reason, the payment object was blank so we don't have full info on their set default payment method
      // Call DWGetTokenInfo to get the full list of payment methods and find the default one from there
      // If for some reason this API fails we'll still load the page but the user will be barred from enrolling in autopay with their default payment method (since we don't know what it is)
      this.findDefaultPaymentMethod(); // If default payment method is found, we will set the order for autopay options then
    }
  }

// auto-redeem.component.ts

// loadAutoPayOptionsPPI() {
//     this.loading = false;
//     console.log("DEBUG walletDetails for PPI:", this.walletDetails);

//     // 1. Determine Initial Toggle State
//     // Read the saved auto-redeem status from the wallet details.
//     const isAutoRedeemSaved = this.walletDetails?.isDWAutoAutoRedeem?.toLowerCase() === 'true';

//     // 2. Set Toggle and Text
//     this.autopayToggle = isAutoRedeemSaved;
//     this.toggleText = isAutoRedeemSaved ? 'On' : 'Off';
//     this.initialAutoRedeemStatus = isAutoRedeemSaved;

//     // 3. Check for Default Payment Method (a requirement for auto-redeem)
//     const hasDefaultPayment = this.walletDetails?.defaultPaymentMethod?.toLowerCase() === 'true';

//     if (hasDefaultPayment) {
//        // this.disableButton = false; // Enable Confirm button since requirements are met

//        if (!isAutoRedeemSaved) {
//             this.disableButton = true; // ✅ Disabled when starting OFF
//         } else {
//             this.disableButton = false; // ✅ Enabled when starting ON
//         }

//         if (this.walletDetails?.payment?.cardType && this.walletDetails?.payment?.last4Digits) {
//             // Case A: Default payment info is available in walletSummary
//             console.log("DEBUG: PPI has default payment info, setting options based on saved state.");
            
//             this.setDefaultPaymentInfo(); // For displaying card details

//             // Initialize options array. The 'checked' status matches the saved toggle state.
//             // Note: PPI Auto Redeem logic often implies the default payment method is implicitly used
//             // and only displays Rewards and Cash as the 'sequence' options.
//             this.autopayOptions = [
//                 // Set checked status based on the saved isAutoRedeemSaved flag
//                 { key: 'rewards', checked: isAutoRedeemSaved, disabled: false },
//                 { key: 'cash', checked: isAutoRedeemSaved, disabled: false }
//             ];
            
//         } else {
//             // Case B: Default payment method is set but details are missing (Fallback needed)
//             console.log("DEBUG: PPI defaultPaymentMethod true but no payment object → calling fallback.");
//             this.findDefaultPaymentMethod(); 
            
//             // Note: findDefaultPaymentMethod() should handle setting options/error if successful.
//             // If the fallback fails, it sets systemError/defaultError/disableButton.
//         }

//     } else {
//         // Case C: No default payment method set (Error state)
//         console.log("DEBUG: PPI has NO default payment method set. User cannot enroll.");
        
//         // Set error flags and disable button
//         this.disableButton = true;
//         this.defaultError = true;
        
//         // Force toggle OFF and unchecked options, as auto-redeem is not possible
//         this.autopayToggle = false; 
//         this.toggleText = 'Off';
//         this.autopayOptions = [
//             { key: 'rewards', checked: false, disabled: false },
//             { key: 'cash', checked: false, disabled: false }
//         ];
//     }

//     console.log("DEBUG autopayOptions after PPI setup:", this.autopayOptions);
// }


loadAutoPayOptionsPPI() {
    this.loading = true;
    this.systemError = false;
    // Keep this commented out: // this.defaultError = false;

    console.log("DEBUG walletDetails for PPI:", this.walletDetails);

    // 1. Determine Initial Toggle State
    const isAutoRedeemSaved = this.walletDetails?.isDWAutoAutoRedeem?.toLowerCase() === 'true';
    const hasDefaultPayment = this.walletDetails?.defaultPaymentMethod?.toLowerCase() === 'true';
    
    // Set initial toggle state properties
    this.autopayToggle = isAutoRedeemSaved;
    this.toggleText = isAutoRedeemSaved ? 'On' : 'Off';
    this.initialAutoRedeemStatus = isAutoRedeemSaved;

    // 2. Set Button and Error Status (Based on New PPI Requirement)
    
    // 💡 Requirement: Button is DISABLED if the toggle is OFF (no selection made).
    // 💡 Requirement: The defaultError flag MUST be FALSE initially.
    this.disableButton = !isAutoRedeemSaved; // Disabled initially if it's OFF
    this.defaultError = false;               // **CRITICAL:** Do not show the error initially

    // 3. Handle Payment Info Display (Only necessary if a default card exists)
    if (hasDefaultPayment) {
        if (this.walletDetails?.payment?.cardType && this.walletDetails?.payment?.last4Digits) {
            // Case A: Default payment info is available 
            this.setDefaultPaymentInfo(); // Display card details
        } else {
            // Fallback needed to retrieve card details for display
            console.log("DEBUG: PPI defaultPaymentMethod true but no payment object → calling fallback.");
            this.findDefaultPaymentMethod(); 
            return; // Exit here, as findDefaultPaymentMethod() handles loading state
        }
    }
    // 💡 If hasDefaultPayment is false, we skip card info display and proceed directly.

    // 4. CALL SEQUENCE API TO LOAD CHECKBOX STATE
    this.loadPpiAutoRedeemSequence(isAutoRedeemSaved);

    console.log("DEBUG autopayOptions after PPI setup:", this.autopayOptions);
}



loadPpiAutoRedeemSequence(isAutoRedeemActive: boolean) {
    const request = {
        walletID: this.walletDetails?.walletID,
        walletRole: this.walletRole, // Should be 'admin'
        sessionID: sessionStorage.getItem('SessionID')
    };

    // If Auto Redeem is OFF, skip API call and initialize to OFF state immediately.
    if (!isAutoRedeemActive) {
        this.initializePpiOptions(false); // Initializes array to unchecked, default order
        this.loading = false;
        return;
    }

    // Call the sequence API for the saved configuration
    this.getAutoPaySequence.getAutoPaySequenceResponsePPI(request).subscribe(
        data => {
            this.loading = false;
            
            if (data?.success === true) {
                // 1. Initialize options array with checked status (sets default order: Rewards at index 0)
                const rewardsChecked = String(data.isRewardsSelected).toLowerCase() === 'true';
                const cashChecked = String(data.isCashSelected).toLowerCase() === 'true';
                this.initializePpiOptions(true, rewardsChecked, cashChecked);

                // 2. *** CRITICAL FIX: REORDER ARRAY BASED ON API SEQUENCE ***
                const rewardsSequence = data.rewardsSequence; // e.g., "2"
                const cashSequence = data.cashSequence;       // e.g., "1"

                // Check if Cash has sequence '1' and Rewards has sequence '2'
                if (cashSequence === "1" && rewardsSequence === "2") {
                    // Current array: [Rewards, Cash] -> Desired: [Cash, Rewards]
                    
                    // We swap the element at index 1 (Cash) with the element at index 0 (Rewards).
                    // We use hardcoded indices (0 and 1) for simplicity since the array is only 2 elements.
                    moveItemInArray(this.autopayOptions, 1, 0); 
                    
                    console.log("DEBUG: Array reordered: Cash is now first.");
                }
                
                // 3. Handle successful data retrieval
                
            } else {
                // API failed to return sequence data despite Auto Redeem being ON
                this.initializePpiOptions(false); 
                this.systemError = true;
                this.disableButton = true;
                console.error("Failed to retrieve PPI Auto Redeem sequence data.");
            }
        }, error => {
            this.loading = false;
            this.systemError = true;
            this.disableButton = true;
            console.error("API Error retrieving PPI Auto Redeem sequence.", error);
        }
    );
}

/**
 * Helper to initialize or reset the options array.
 */
initializePpiOptions(
    isAutoRedeemActive: boolean, 
    rewardsChecked: boolean = false, 
    cashChecked: boolean = false
) {
    this.autopayToggle = isAutoRedeemActive;
    this.toggleText = isAutoRedeemActive ? 'On' : 'Off';
    
    // PPI only deals with Rewards and Cash (Default Payment Method is implicit)
    this.autopayOptions = [
        { key: 'rewards', checked: rewardsChecked, disabled: false },
        { key: 'cash', checked: cashChecked, disabled: false }
    ];
}

  findDefaultPaymentMethod() {
    let walletID = JSON.parse(sessionStorage.getItem('WalletID')!);
    this.getpayintoken.fetchpayintokens(walletID).subscribe(
      data => {
        if (data?.paymentMethods) {
          let allMethods = data.paymentMethods;
          let defaultMethod = allMethods?.find(x => x.isDefaultPaymentMethod == "true");
          
          if (defaultMethod) {
            this.cardType = defaultMethod.cardType;
            this.lastFourDigits = defaultMethod.last4Digits;
            this.ccExpiration = defaultMethod.ccexpiration;

            if (this.cardType == 'Visa' || this.cardType == 'Mastercard' || this.cardType == 'Amex') {
              this.isExpired = this.checkCCExpiration(defaultMethod.ccexpiration, 'expired');
              this.isWarning = this.checkCCExpiration(defaultMethod.ccexpiration, 'warning');

              if (this.isExpired || this.isWarning) {
                // If it's expired or close to expiring, don't allow them to continue, show error message.
                this.loading = false;
                this.disableButton = true;
              }
            }

            this.setOrderForAutopayOptions();
          } else {
            // If user does not have a default payment method set, prompt them with a pop-up that they need to set a default payment method.
            this.loading = false;
            this.disableButton = true;
            this.defaultError = true;
            if (!this.isPPI) { 
                        this.openSetDefaultPaymentModal('auto-redeem');
                    }
      //      this.openSetDefaultPaymentModal('auto-redeem');
          }
        } else {
          // We couldn't find their default payment method, treat as system error.
          this.loading = false;
          this.disableButton = true;
          this.systemError = true;
        }
      }, error => {
        // We couldn't find their default payment method, treat as system error.
        this.loading = false;
        this.disableButton = true;
        this.systemError = true;
      }
    );
  }

setDefaultPaymentInfo() {
  this.cardType = this.walletDetails?.payment?.cardType;
  this.lastFourDigits = this.walletDetails?.payment?.last4Digits;
  this.ccExpiration = this.walletDetails?.payment?.ccExpiration;

  if (this.cardType !== 'EC' && this.cardType !== 'ECP' && this.ccExpiration) {
    // Normalize expiration format
    let normalizedExpiration = this.ccExpiration.replace('/', ''); // "0630" -> MMYY

    this.isExpired = this.checkCCExpiration(normalizedExpiration, 'expired');
    this.isWarning = this.checkCCExpiration(normalizedExpiration, 'warning');

    if (this.isExpired || this.isWarning) {
      this.loading = false;
      this.disableButton = true;
    }
  }
}


  setOrderForAutopayOptions() {
    if (this.walletDetails?.isDWAutoPay == '0') {
      // If they don't have autopay enabled, load the screen with all 3 options unchecked and not draggable
      this.loading = false;
      this.autopayToggle = false;
      this.toggleText = 'Off';
      this.autopayOptions = [
        {key: 'rewards', checked: false, disabled: false},
        {key: 'cash', checked: false, disabled: false},
        {key: 'default', checked: false, disabled: true},
      ];
      if (this.isAutoTransferOn) {
        const filteredArray = this.autopayOptions.filter(obj => obj.key !== 'cash');
        this.autopayOptions = filteredArray;
      }
      if(this.isBilliant)
      {
        const filteredArray = this.autopayOptions.filter(obj => obj.key !== 'rewards');
        this.autopayOptions = filteredArray;
      }
    } else if (this.walletDetails?.isDWAutoPay == '1') { 
      // If they do have autopay enabled already, call getAutoPaySequence to get the current order of selected autopay options
      let request = {
        walletID: this.walletDetails?.walletID,
        walletRole: 'admin',
        sessionID:sessionStorage.getItem('SessionID')
      }
      this.userService.getAutoPaySequence(request).subscribe(
        data => {
          this.loading = false;
          if (data) {
            // There are two possible scenarios where cash should be displayed before, both occur when cashSequence == 1
            if (data?.cashSequence == '1') {
              // Cash goes before rewards
              this.autopayToggle = true;
              this.toggleText = 'On';
              this.autopayOptions = [
                {key: 'cash', checked: data?.isCashSelected, disabled: false},
                {key: 'rewards', checked: data?.isRewardsSelected, disabled: false},
                {key: 'default', checked: true, disabled: true},
              ];          
            } else {
              // For any other scenario, use the default order (which is rewards goes before cash)
              this.autopayToggle = true;
              this.toggleText = 'On';
              this.autopayOptions = [
                {key: 'rewards', checked: data?.isRewardsSelected, disabled: false},
                {key: 'cash', checked: data?.isCashSelected, disabled: false},
                {key: 'default', checked: true, disabled: true},
              ];  
            }
            if (this.isAutoTransferOn) {
              const filteredArray = this.autopayOptions.filter(obj => obj.key !== 'cash');
              this.autopayOptions = filteredArray;
            }
            if (this.isBilliant) {
              const filteredArray = this.autopayOptions.filter(obj => obj.key !== 'rewards');
              this.autopayOptions = filteredArray;
            }
          } else {
            // Autosequence didn't return anything, display error message.
            this.loading = false;
            this.disableButton = true;
            this.systemError = true;
          }
        }, error => {
          this.loading = false;
          this.disableButton = true;
          this.systemError = true;
        }
      );
    }
    
  }

  anyOptionIsSelected(item: any) {
    return item.checked;
  }



  onChange(event: any, item: any) {
  item.checked = event?.target?.checked;

  // If any option is checked, turn ON autopay
  if (this.autopayOptions.find(opt => opt.checked)) {
    this.autopayToggle = true;
    this.toggleText = 'On';

    // Default must always stay checked if toggle is ON
    for (let opt of this.autopayOptions) {
      if (opt.key === 'default') {
        opt.checked = true;
      }
    }

    this.disableButton = false; // ✅ enable confirm
  } else {
    // If nothing is selected, turn OFF
    this.autopayToggle = false;
    this.toggleText = 'Off';
  //  this.disableButton = true; // ✅ disable confirm
  }
}

  // If the autopay toggle is toggled on or off, check/uncheck all 3 autopay options
onToggleChange(event: any) {
  this.toggleText = this.autopayToggle ? 'On' : 'Off';

  // Update all options when toggling
  for (let i = 0; i < this.autopayOptions.length; i++) {
    this.autopayOptions[i].checked = this.autopayToggle;
  }
if (this.initialAutoRedeemStatus === true) {
        // SCENARIO 1: Started ON. Button is ALWAYS ENABLED regardless of the new toggle state.
        this.disableButton = false;
        
    } else {
        // SCENARIO 2: Started OFF. Button status must match the toggle state.
        // ON -> Enabled (user initiating enrollment)
        // OFF -> Disabled (user abandoning change, returning to initial OFF state)
        // Note: We use !this.autopayToggle to check if the toggle is currently OFF.
        this.disableButton = !this.autopayToggle; 
    }
}

  // Both of these indexes will return -1 when not true (aka the option was not checked)
  // And return 0 or 1 if they are checked, depending on where it is in the array
  rewardsIndex(item: any) {
    return item.key == 'rewards' && item.checked == true;
  }

  cashIndex(item: any) {
    return item.key == 'cash' && item.checked == true;
  }
  
openAutoRedeemDialog() {
  this.successMessage = false;
  this.storeInitialState();

  const defaultToken = this.walletDetails?.token?.replace(/^"(.*)"$/, '$1');
  const sessionID = sessionStorage.getItem("SessionID");

  let payload: any;
  const currentRewardsIndex = this.autopayOptions.findIndex(this.rewardsIndex);
  const currentCashIndex = this.autopayOptions.findIndex(this.cashIndex);
  const isRewardsSelected = currentRewardsIndex > -1;
  const isCashSelected = currentCashIndex > -1;

  // 1. PPI Payload Construction (DWSetAutoRedeem)
  if (this.isPPI) {
    let paymentPreference: string | undefined = undefined;

    if (isRewardsSelected && isCashSelected) {
      // 2 for Rewards first, 1 for Cash first
      paymentPreference = currentRewardsIndex < currentCashIndex ? "2" : "1";
    } else if (isRewardsSelected) {
      paymentPreference = "0"; // Arbitrary preference if only Rewards is selected
    } else if (isCashSelected) {
      paymentPreference = "0"; // Arbitrary preference if only Cash is selected
    }

    payload = {
      walletID: this.walletDetails?.walletID,
      customerID: sessionStorage.getItem("PPICustomerID"), // Required by DWSetAutoRedeem
      sessionID: sessionID,
      optedBy: sessionStorage.getItem("PPIUserID"), // Required by DWSetAutoRedeem
      
      // Auto Redeem Status (Boolean value)
      autoRedeem: this.autopayToggle, 
      
      // Option Selections (Boolean values)
      rewardsOption: isRewardsSelected,
      cashOption: isCashSelected,
      
      // Preference/Sequence (send 1 or 2 as string, or undefined/0)
      paymentPreference: paymentPreference,
    };

    // CRITICAL FIX: Explicitly send OFF strings for unenrollment API success
    if (!this.autopayToggle) {
        payload.paymentPreference = "0"; // Send "0" for unenrollment sequence/preference
        payload.rewardsOption = false;   
        payload.cashOption = false;  
        payload.autoRedeem = false;    
    }
  } 
  
  // 2. ONL Payload Construction (DWSetAutoPay - Use for ONL)
  else {
    let rewardsSequence = "";
    let cashSequence = "";
    let isCashSelectedValue: boolean | undefined = undefined;
    let isRewardsSelectedValue: boolean | undefined = undefined;

    if (this.autopayToggle) {
      // Logic for ON state
      isRewardsSelectedValue = isRewardsSelected;
      isCashSelectedValue = isCashSelected;

      if (isRewardsSelected && !isCashSelected) {
        rewardsSequence = "1";
        cashSequence = "0";
      } else if (!isRewardsSelected && isCashSelected) {
        rewardsSequence = "0";
        cashSequence = "1";
      } else if (isRewardsSelected && isCashSelected) {
        rewardsSequence = (currentRewardsIndex + 1).toString();
        cashSequence = (currentCashIndex + 1).toString();
      } else {
        rewardsSequence = "0";
        cashSequence = "0";
      }
    } else {
      // Logic for OFF state (Unenrollment)
      rewardsSequence = undefined; // ONL API often handles undefined/null better
      cashSequence = undefined;
      isRewardsSelectedValue = false;
      isCashSelectedValue = false;
    }

    payload = {
      walletID: this.walletDetails?.walletID,
      walletRole: this.ONLSessionDetails?.navigatingSystemRole,
      policyNo: this.ONLSessionDetails?.productSystemIdentifier1, // ONL specific ID
      isAutoPay: this.autopayToggle,
      rewardsSequence: rewardsSequence,
      cashSequence: cashSequence,
      defaultPaymentMethodToken: this.autopayToggle ? defaultToken : undefined,
      isCashSelected: isCashSelectedValue,
      isRewardsSelected: isRewardsSelectedValue,
      pcAccountNo: this.ONLSessionDetails?.productSystemIdentifier2,
      productSystem: this.ONLSessionDetails?.productSystem,
      sessionID: sessionID,
      billingSystem: this.ONLSessionDetails?.billingSystem,
      payorID: this.ONLSessionDetails?.payorID
    };
  }
  
  // Final assignment for dialog component
  this.currentSelection = payload;

  // 3. Open Dialog (Remains unchanged)
  const config = new MatDialogConfig();
  config.autoFocus = false;
  config.data = {
    currentSelection: this.currentSelection,
    autopayOptions: this.autopayOptions,
    defaultMethod: {
      cardType: this.cardType,
      lastFourDigits: this.lastFourDigits,
      ccExpiration: this.ccExpiration,
    },
    isAutoPay: this.autopayToggle,
    skipFirstStep: !this.autopayToggle,
    isPPI: this.isPPI
  };

  const dialogRef = this.dialog.open(AutoRedeemDialogComponent, config);
  
  // 4. Handle Subscription (Error/Success Logic Remains Unchanged)
  dialogRef.componentInstance.autopayResult.subscribe(result => {
    if (result === true) {
      this.successMessage = true;
      this.systemError = false;   
      this.disableButton = false;
      this.updateWalletSummary();
    } else if (result === 'restore') {
      this.restoreInitialState();
      this.systemError = false;   
      this.disableButton = false;
    } else if (result === 'cancel') {
      this.loadAutoPayOptions();
      this.systemError = false;   
      this.disableButton = false;
    } else {
      this.successMessage = false;
      this.systemError = false;   
      this.disableButton = false;
      this.restoreInitialState();
    }
  });
}

  storeInitialState() {
    this.initialState = {
      autopayToggle: this.autopayToggle,
      autopayOptions: JSON.parse(JSON.stringify(this.autopayOptions)), // Deep copy
    };
  }

  restoreInitialState() {
    this.autopayToggle = this.initialState.autopayToggle;
    this.autopayOptions = JSON.parse(JSON.stringify(this.initialState.autopayOptions)); // Deep copy
  //  console.log("Restore Initial State: ", this.autopayOptions)
  }

  processAndOpenFinalDialog() {
    this.buttonLoading = true;
    this.getAutoPaySequence.setAutoPay(this.currentSelection).subscribe(
      data => {
        this.buttonLoading = false;
        if (data.success) {
          this.successMessage = true;
          this.updateWalletSummary();
          let config = new MatDialogConfig();
          config.autoFocus = false;
          config.data = {
            currentSelection: this.currentSelection,
            autopayOptions: this.autopayOptions,
            defaultMethod: {
              cardType: this.cardType,
              lastFourDigits: this.lastFourDigits,
              ccExpiration: this.ccExpiration,
            },
            isAutoPay: this.autopayToggle,
            skipFirstStep: true, // Ensure this is set to true
            isPPI: this.isPPI,
            texts: {
                confirmStop: this.isPPI
                ? 'Are you sure you want to stop Auto Redeem?'
                : 'Are you sure you want to stop Auto Pay & Redeem?'
             }
          };
  
          let dialogRef = this.dialog.open(AutoRedeemDialogComponent, config);
          dialogRef.componentInstance.currentStep = 1; // Set to the final step directly
          dialogRef.componentInstance.autopayResult.subscribe(result => {
            if (result) {
              this.successMessage = true;
              this.updateWalletSummary();
            } else {
             // this.successMessage = false;
            }
          });
        } else {
          this.systemError = true;
        }
      }, error => {
        this.buttonLoading = false;
        this.systemError = true;
      }
    );
  }

  openSetDefaultPaymentModal(origin:string): void {
    if (!this.modalOpened) { // Check if the modal has already been opened
      this.modalOpened = true; // Set the flag to true
      const dialogRef = this.dialog.open(ModalDefaultPaymentComponent, {
        width: '600px', // Set the width of the modal
        data: { origin}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === 'accept') {
          // Navigate to manage-payment with from=auto-redeem
          this.router.navigate(['/preferences/manage-payment'], {
            queryParams: { from: 'auto-redeem' }
          });
        }
      });
    }
  }

  // openSetDefaultPaymentModal() {
  //   let config = new MatDialogConfig();
  //   config.autoFocus = false;
  //   config.data = "setting up Auto Redeem & Pay";
  //   let dialogRef = this.dialog.open(ModalDefaultPaymentComponent, config);
  // }

  // gotoSetDefaultPayment(){
  //   this.router.navigate(['/preferences/manage-payment'], { relativeTo:this.route });
  // }

  gotoSetDefaultPayment() {
    this.router.navigate(['/preferences/manage-payment'], {
      queryParams: { from: 'auto-redeem' } // Pass the parameter
    });
  }
  


  updateWalletSummary() {
    let request = {
        sessionID: sessionStorage.getItem("SessionID"),
        walletID: JSON.parse(sessionStorage.getItem('WalletID')!),
        walletRole: JSON.parse(sessionStorage.getItem('WalletRole')!)
    };
    
    this.userService.getWalletSummary(request).subscribe(
        data => {
            // Determine the correct wallet object from the new API structure
            let activeWallet = null;
        if (this.isPPI) {
                if (data?.ppi?.wallet) {
                    activeWallet = data.ppi.wallet;
                    console.log("Data for PPI Wallet: ", activeWallet);

                    if (data?.ppi?.wallet?.payment) {
                        activeWallet.payment = data.ppi.wallet.payment;
                    }
                }
            } else {
                // Not PPI, so use ONL (or legacy)
                if (data?.onl?.wallet) {
                    activeWallet = data.onl.wallet;
                    console.log("Data for ONL Wallet: ", activeWallet);
                }
            }

             // Fallback for general 'data?.wallet' if specific ONL/PPI extraction failed
            if (!activeWallet && data?.wallet) {
                activeWallet = data.wallet;
            }
            

            // Check if a valid wallet object was found before trying to save it
            if (activeWallet) {
                // Now, save the correct wallet object to sessionStorage
                sessionStorage.setItem('walletDetails', JSON.stringify(activeWallet));
                 console.log("DEBUG walletDetails saved:", activeWallet);
            } else {
                console.error('Wallet data not found in API response.');
            }
        },
        error => {
            console.error('Error fetching wallet summary:', error);
        }
    );
}

  checkCCExpiration(ccExpiration, type) {
    const currentDate = new Date();let expirationYear:number;let expirationMonth:number;
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Adding 1 because getMonth() returns 0-based index
    if(ccExpiration.length==6){ 
      expirationYear = parseInt(ccExpiration.slice(0, 4));
    expirationMonth = parseInt(ccExpiration.slice(4, 6));
    }
    else if(ccExpiration.length==4){ 
      expirationYear =parseInt(currentYear.toString().slice(0,2)+ ccExpiration.slice(2, 4));
    expirationMonth = parseInt(ccExpiration.slice(0, 2));
    }

    let isExpired;
    let isWarning;

    if (currentYear > expirationYear) {
      // Card is expired if current year is greater than expiration year
      isExpired = true;
      isWarning = false;
    } else if (currentYear === expirationYear && currentMonth > expirationMonth) {
      // Card is expired if current year is equal to expiration year and current month is greater than expiration month
      isExpired = true;
      isWarning = false;
    } else if (currentYear === expirationYear && currentMonth === expirationMonth) {
      const daysInMonth = this.daysInMonth(currentMonth, currentYear);
      const daysUntilExpiration = daysInMonth - currentDate.getDate();
      // Card technically does not expire until the end of the month, but if there are 5 or fewer days until expiration
      // Disallow them from using the payment method - so we set it as 'warning' and not 'expired' but user not allowed to use the payment method in either case.
      if (daysUntilExpiration <= 5) {
        isExpired = false;
        isWarning = true;
      } else {
        // There are still more than 5 days in the month before card expires, let them use the payment method.
        isExpired = false;
        isWarning = false;
      }
    } else {
      // Card is not expired
      isExpired = false;
      isWarning = false;
    }

    if (type == 'expired') {
      return isExpired;
    } else if (type == 'warning') {
      return isWarning;
    }
  }

  daysInMonth(m, y) {
    // month is 0-based: Jan = 0, Dec = 11
    // (m-1 ? Not February : February) checks if month is Feb
    // y & (y % 25 ? 3 : 15) is falsy for leap years, hence 31-2 days in Feb- otherwise, it's 31-3 days
    // m % 7 makes it so m is even for months with 31 days, odd for rest
    // subtracting lowest bit &1 results in 31-1 days for April/June/Sept/Nov, 31-0 for the rest
    // referenced stackexchange post for this function
    return 31 - (m - 1 ? m % 7 & 1 : y & (y % 25 ? 3 : 15) ? 3 : 2);
  }

  formatExpirationDate(expiration: string): string {
    if (!expiration || expiration.length !== 6)
      if(expiration.length==4)
        { const month = expiration.substring(0, 2); // Extract the year
          const year = expiration.substring(2, 4);
          
          return `${month}/${year}` }// Handle invalid input
  
    const year = expiration.substring(0, 4); // Extract the year
    const month = expiration.substring(4, 6); // Extract the month
  
    return `${month}/${year.substring(2, 4)}`; // Format as MM/YY
  }
}
